import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { GetCepPercentageOfApproved } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_CEPS_PERCENTAGE_OF_APPROVED_LAZY = gql`
query GetCustomerEngagementPlanningsPercentageOfApproved($filters: DashboardFilter!) {
  getCustomerEngagementPlanningsPercentageOfApproved(filters: $filters) {
    status
    percentage
  }
}
`;

type ResultType = {
  getCustomerEngagementPlanningsPercentageOfApproved: GetCepPercentageOfApproved[];
};

type UseGetCepsPercentageOfApprovedLazy = () => {
  getCepsPercentageOfApprovedLazyQuery: Function;
  loading: boolean;
  error?: ApolloError;
  data: GetCepPercentageOfApproved[];
};

const useGetCustomerEngagementPlanningsPercentageOfApprovedLazyQuery: UseGetCepsPercentageOfApprovedLazy = () => {
  const [getCepsPercentageOfApprovedLazyQuery, { data, loading, error }] = useLazyQuery<ResultType>(GET_CEPS_PERCENTAGE_OF_APPROVED_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName:
        'getCepsPercentageOfApprovedLazy.ts - useGetCustomerEngagementPlanningsPercentageOfApprovedLazyQuery',
    });
  }

  return {
    getCepsPercentageOfApprovedLazyQuery,
    data: data?.getCustomerEngagementPlanningsPercentageOfApproved || [],
    loading,
    error,
  };
};

export default useGetCustomerEngagementPlanningsPercentageOfApprovedLazyQuery;
